// Mock data - stored separately so backend integration is easy later

export const NAV_ITEMS = [
  { label: 'TikTok', href: '#tiktok' },
  { label: 'Products', href: '#products' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Tools', href: '#tools' },
  { label: 'About', href: '#about' },
  { label: 'Resources', href: '#resources' },
];

export const BRAND_LOGOS = [
  'Revolut', 'IKEA', 'Gymshark', 'Nutribullet', 'Rockport',
  'SmileDirectClub', 'Timberland', 'Nutrafol', 'Glossier', 'Munchkin', 'Conair',
];

export const TOOLS = [
  {
    id: 'growth',
    tag: 'Auto-Grow',
    title: 'Get more real Instagram followers automatically with our AI growth engine',
    desc: 'Just 5 minutes of setup gets you 730 hours of growth each month. All automatic. All organic results.',
    bullets: ['24/7 Growth Engine', 'On-Demand Experts', '10x Better than Ads'],
    icon: 'Rocket',
    accent: 'from-[#3b82f6] to-[#ec4899]',
  },
  {
    id: 'analytics',
    tag: 'Live Reports',
    title: 'Track your growth with beautiful Instagram Analytics & insights',
    desc: 'Measure performance, create custom reports and get personalized recommendations to grow faster.',
    bullets: ['Track Growth Results', 'Audience Analytics', 'AI Strategy Optimization'],
    icon: 'BarChart3',
    accent: 'from-[#0ea5e9] to-[#a855f7]',
  },
  {
    id: 'aimatch',
    tag: 'AI-Match™',
    title: 'Targeted Follower Targeting powered by AI',
    desc: 'Train your {{brand}} AI model to identify your ideal followers by swiping accounts, just like Tinder.',
    bullets: ['Growth Auto-Optimization', 'Location Targeting Filter', 'Smart Followers Magnet'],
    icon: 'Target',
    accent: 'from-[#8b5cf6] to-[#ec4899]',
  },
  {
    id: 'experts',
    tag: 'Experts',
    title: 'On-demand support from your dedicated growth team',
    desc: 'Get your own 24/7 dedicated team of Instagram growth experts. We do all the work for you.',
    bullets: ['Dedicated Manager', 'Live Chat 24/7', 'LA & London Team'],
    icon: 'Users',
    accent: 'from-[#f43f5e] to-[#f59e0b]',
  },
];

export const STATS = [
  { value: '55,000+', label: 'Happy Users' },
  { value: '~4,500', label: 'New Followers / Month' },
  { value: '7M+', label: 'Total Hours Saved' },
  { value: '9.8/10', label: 'Net Promoter® Score' },
];

export const PRESS_QUOTES = [
  {
    source: 'Entrepreneur.com',
    quote: '{{brand}} Is The Best Instagram Tool for Organic Results',
  },
  {
    source: 'SocialMediaExplorer',
    quote: 'The Best Instagram Bot and Growth Service in 2026',
  },
  {
    source: 'Influencive',
    quote: '{{brand}} is a must have for any Instagram marketer',
  },
  {
    source: 'G2',
    quote: '4.84 / 5 average rating from verified users',
  },
];

export const TESTIMONIALS = [
  {
    name: 'Gary Vaynerchuk',
    role: 'CEO, VaynerMedia',
    quote: 'You can spend thousands of dollars on ads or buying followers to build a meaningful audience on Instagram before seeing that it’s a complete waste. At the end of the day, all that matters is that your followers care about your page and engage with what you’re offering, and {{brand}} is the best Instagram growth service to get you there.',
    avatar: 'GV',
  },
  {
    name: 'Todrick Hall',
    role: '@todrick · 1.7M followers',
    quote: '{{brand}} helped me connect with fans who actually engage. My comments and DMs skyrocketed within the first 30 days.',
    avatar: 'TH',
  },
  {
    name: 'Nicolette Mason',
    role: 'Influencer · 191K followers',
    quote: 'Real growth, real followers, zero drama. The AI targeting is scary good — my niche audience just keeps showing up.',
    avatar: 'NM',
  },
  {
    name: 'Chad Carroll',
    role: 'Realtor · +63K growth',
    quote: 'I’ve tried every service out there. {{brand}} is the only one that delivered organic followers who actually became clients.',
    avatar: 'CC',
  },
  {
    name: 'Jake Pitts',
    role: '@jakepittsbvb · 592K followers',
    quote: 'The dashboard analytics are next level. I can see exactly what’s working and adjust on the fly.',
    avatar: 'JP',
  },
  {
    name: 'Janelle Pierzina',
    role: 'Creator · 253K followers',
    quote: 'Setup took me 3 minutes. Growth started the same day. Nothing else even comes close.',
    avatar: 'JP',
  },
];

export const CLIENT_STORIES = [
  {
    category: 'Retail',
    handle: '@topman',
    name: 'Topman',
    member: 'Nov 2018',
    followers: '755K',
    growth: '+213K',
  },
  {
    category: 'Influencer',
    handle: '@nicolettemason',
    name: 'Nicolette Mason',
    member: 'Jan 2021',
    followers: '191K',
    growth: '+17K',
  },
  {
    category: 'Realtor',
    handle: '@chadcarroll',
    name: 'Chad Carroll',
    member: 'Dec 2019',
    followers: '512K',
    growth: '+63K',
  },
  {
    category: 'Entrepreneur',
    handle: '@grantcardone',
    name: 'Grant Cardone',
    member: 'Jul 2019',
    followers: '3M',
    growth: '+122K',
  },
  {
    category: 'E-commerce',
    handle: '@away',
    name: 'AWAY',
    member: 'Apr 2020',
    followers: '563K',
    growth: '+78K',
  },
  {
    category: 'E-commerce',
    handle: '@papersource',
    name: 'Paper Source',
    member: 'Sept 2019',
    followers: '258K',
    growth: '+188K',
  },
  {
    category: 'Retail',
    handle: '@moonjuice',
    name: 'Moon Juice',
    member: 'Feb 2019',
    followers: '310K',
    growth: '+157K',
  },
];

export const INSTAGRAM_PLANS = [
  {
    id: 'starter',
    name: 'Starter',
    tagline: 'Ideal for personal profiles and small businesses.',
    price: 29,
    range: '1,500 - 3,000 Followers',
    highlight: false,
    features: [
      '1,500 - 3,000 Followers',
      'Results Start Within 1 Day',
      'Higher Reach & Engagement',
      'Genuine Comments',
      'Targeted, Organic Followers',
      'Guaranteed Results or It’s Free',
      'LA & London Team Support',
      'Real-Time Analytics',
    ],
  },
  {
    id: 'pro',
    name: 'Pro',
    tagline: 'For creators & brands scaling faster.',
    price: 55,
    range: '4,000 - 6,000 Followers',
    highlight: true,
    features: [
      '4,000 - 6,000 Followers',
      'Results Start Within 1 Day',
      'Higher Reach & Engagement',
      'Genuine Comments',
      'Targeted, Organic Followers',
      'Guaranteed Results or It’s Free',
      'LA & London Team Support',
      'Real-Time Analytics',
      'AI-Powered Growth Engine',
    ],
  },
];

export const TIKTOK_PLANS = {
  monthly: [
    {
      name: 'Grow',
      price: 89,
      range: '800 - 1,500 Followers /mo',
      features: [
        'Instant Start',
        'Targeted TikTok Fans',
        'Guaranteed Results or Free',
        'Real-Time Analytics',
      ],
    },
    {
      name: 'Scale',
      price: 149,
      range: '2,000 - 3,500 Followers /mo',
      features: [
        'Instant Start',
        'Targeted TikTok Fans',
        'Priority Support',
        'AI-Powered Growth',
        'Real-Time Analytics',
      ],
      highlight: true,
    },
    {
      name: 'Elite',
      price: 249,
      range: '4,500 - 7,000 Followers /mo',
      features: [
        'Instant Start',
        'Targeted TikTok Fans',
        'Dedicated Manager',
        'AI-Powered Growth',
        'Advanced Analytics',
      ],
    },
  ],

  yearly: [
    {
      name: 'Grow',
      price: 44,
      range: '800 - 1,500 Followers /mo',
      features: [
        'Instant Start',
        'Targeted TikTok Fans',
        'Guaranteed Results or Free',
        'Real-Time Analytics',
      ],
    },
    {
      name: 'Scale',
      price: 74,
      range: '2,000 - 3,500 Followers /mo',
      features: [
        'Instant Start',
        'Targeted TikTok Fans',
        'Priority Support',
        'AI-Powered Growth',
        'Real-Time Analytics',
      ],
      highlight: true,
    },
    {
      name: 'Elite',
      price: 124,
      range: '4,500 - 7,000 Followers /mo',
      features: [
        'Instant Start',
        'Targeted TikTok Fans',
        'Dedicated Manager',
        'AI-Powered Growth',
        'Advanced Analytics',
      ],
    },
  ],
};

export const FAQS = [
  {
    q: 'Who should use {{brand}}?',
    a: '{{brand}} is for anyone who wants to grow their Instagram or TikTok organically — creators, businesses, agencies, or personal accounts.',
  },
  {
    q: 'How many followers can I get with {{brand}}?',
    a: 'You can expect at least 1,000+ followers per month on the starter plan and up to 6,000+ on Pro. Growth is organic and consistent.',
  },
  {
    q: 'Is {{brand}} safe to use?',
    a: 'Yes. We never use bots or fake accounts. Everything is AI-driven organic engagement, fully compliant with Instagram & TikTok’s ToS.',
  },
  {
    q: 'How long does it take to see results?',
    a: 'You’ll see results within the first 24 hours. Full AI optimization kicks in around day 7.',
  },
  {
    q: 'How does {{brand}} work?',
    a: 'We combine AI-powered audience targeting, nano-interactions, and real-human activity to attract users genuinely interested in your niche.',
  },
  {
    q: 'Can I cancel anytime?',
    a: 'Absolutely. You can pause or cancel your plan from your dashboard at any time — no questions asked.',
  },
];

// Local storage helpers for mocked backend calls.
// These internal keys are kept unchanged intentionally.

const LS_EMAILS = 'plixy_email_captures';
const LS_LEADS = 'plixy_leads';
const ADMIN_PASS = 'plixy2026';

export const saveEmailCapture = (email) => {
  const list = JSON.parse(localStorage.getItem(LS_EMAILS) || '[]');

  list.unshift({
    id: Date.now().toString(),
    email,
    capturedAt: new Date().toISOString(),
    source: 'popup',
  });

  localStorage.setItem(LS_EMAILS, JSON.stringify(list));
  return list;
};

export const saveLead = (lead) => {
  const list = JSON.parse(localStorage.getItem(LS_LEADS) || '[]');

  list.unshift({
    id: Date.now().toString(),
    ...lead,
    createdAt: new Date().toISOString(),
  });

  localStorage.setItem(LS_LEADS, JSON.stringify(list));
  return list;
};

export const getEmails = () =>
  JSON.parse(localStorage.getItem(LS_EMAILS) || '[]');

export const getLeads = () =>
  JSON.parse(localStorage.getItem(LS_LEADS) || '[]');

export const checkAdminPassword = (pwd) => pwd === ADMIN_PASS;

export const ADMIN_HINT = ADMIN_PASS;
